import { useSelector, shallowEqual } from 'react-redux';

import { ASSIGNMENT_RESULT_TYPES } from '@helpers/constants';

import { PROGRESS } from '@components/accuracy-progress-toggle/accuracy-progress-constants';

const useAssignmentResultType = () => {
  const { accuracySubFilter, currentFilter, progressSubFilter } = useSelector(
    state => state.UPFAssignReducer.accuracyProgressToggle,
    shallowEqual
  );

  const subFilter = currentFilter === PROGRESS ? progressSubFilter : accuracySubFilter;
  const assignmentResultType = ASSIGNMENT_RESULT_TYPES[subFilter?.toUpperCase()];

  return {
    assignmentResultType
  };
};

export default useAssignmentResultType;
